import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-headline">Engineering Reliable Digital Systems</h1>
          <p className="hero-subtext">
            Prelybe is a technology and IT solutions company delivering secure, scalable, and practical digital systems for businesses, institutions, and governments.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;

